var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status === true)?_c('div',{staticClass:"tm-attr"},[_c('fa',{attrs:{"icon":"check"}}),_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.label),expression:"label"}]})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }